/** PWA · 我的履歷（本人·手機）。共用 ResumeTabs（self 模式）；2026-10-30 起個人資料全開放本人改、可 reveal 自己身分證。 */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';

import ResumeTabs, { ResumeTabsHandlers } from '../../../components/hr/ResumeTabs';
import { useMessage } from '../../../contexts/MessageContext';
import {
  createMyDetail, deleteMyDetail, getMyHistory, getMyResume, revealMyId, updateMyDetail,
  updateMyResume,
} from '../../../services/eeHrResumeService';
import { HrProfile } from '../../../types/eeHrResume';

const PWAMyResumePage: React.FC = () => {
  const { t } = useTranslation();
  const { showApiError } = useMessage();
  const [profile, setProfile] = useState<HrProfile | null>(null);

  const load = useCallback(async () => {
    try { setProfile(await getMyResume()); } catch (err) { showApiError(err); }
  }, [showApiError]);

  useEffect(() => { load(); }, [load]);

  if (!profile) return <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>;

  const handlers: ResumeTabsHandlers = {
    saveProfile: (u) => updateMyResume(u),
    reveal: () => revealMyId().then((r) => ({ id_number: r.id_number })),
    loadHistory: (offset, limit) => getMyHistory({ offset, limit }),
    createDetail: (section, data) => createMyDetail(section, data),
    updateDetail: (section, id, data) => updateMyDetail(section, id, data),
    deleteDetail: (section, id) => deleteMyDetail(section, id),
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ my: 1 }}>🧑‍💼 {t('hrResume.myTitle', '我的履歷')}</Typography>
      <ResumeTabs profile={profile} mode="self" onReload={load} handlers={handlers} />
    </Box>
  );
};

export default PWAMyResumePage;
